import { defineComponent as _defineComponent } from 'vue'
import { PropType, toRefs, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PieChart',
  props: {
  sections: Array as PropType<
    {
      label: string;
      value: number;
      color: string;
      length: number;
    }[]
  >,
},
  setup(__props) {

const props = __props



const handleSectionClick = (section: any, event: any) => {
  console.log(`${section.label} clicked.`);
};
const handleMouseOver = (section: any, event: any) => {
  const element = document.querySelector(`[data-label="${section.label}"]`);
  element.classList.add("hover");
  //   event.target.style = `background-color: ${section.color};`;
};
const handleMouseOut = (section: any, event: any) => {
  const element = document.querySelector(`[data-label="${section.label}"]`);
  element.classList.remove("hover");
};

return { __sfc: true,props, handleSectionClick, handleMouseOver, handleMouseOut }
}

})